import React from "react";
import { HERO_OVERLAY, IMAGE_APP_LAYERS } from "../images";

import Title from "../title/title";
import Heading from "../heading/heading";
import Container from "../container/container";
import "./headerImage.css";
import "./headerLabel.css";
import ProductNotificationsSubscribe from "../apiProduct/productNotificationsSubscribe/productNotificationsSubscribe";
import Divider from "../divider/divider";

const HeaderImage = (props) => {
  const {
    uuid,
    commercialProduct,
    subscribed,
    title,
    image,
    description,
    children,
    noDivider,
    ...imgProps
  } = props;
  return (
    <section className="home-top-banner">
      <div className="home-top-banner-image-wrapper">
        {title && (
          <div className="home-page-title">
            <Title type="small">{title.sub}</Title>
            <Title type="section">
              <Heading level="1">
                <span style={{ marginRight: 8 }}>
                  {title.main.toUpperCase()}
                </span>
                {uuid && !commercialProduct && (
                  <ProductNotificationsSubscribe
                    uuid={uuid}
                    subscribed={subscribed}
                  />
                )}
              </Heading>
            </Title>
          </div>
        )}
        <div className="home-image-outer-wrapper">
          <div className="home-image-inner-wrapper">
            <div className="">
              {image ? (
                image.imageFile ? (
                  <img src={image.imageFile} alt={image.alt} {...imgProps} />
                ) : (
                  <img src={image.url} alt={image.alt} {...imgProps} />
                )
              ) : (
                <img
                  src={IMAGE_APP_LAYERS}
                  alt="Default API Product"
                  {...imgProps}
                />
              )}
            </div>
          </div>
          <div className="over-image-21">
            <img src={HERO_OVERLAY} alt="product overlay" />
          </div>
        </div>
        {(description || children) && (
          <div className="home-image-label">
            {description && (
              <div className="home-image-txt">
                <span dangerouslySetInnerHTML={{ __html: description }} />
              </div>
            )}
            {children}
          </div>
        )}
      </div>
      {!noDivider && <Divider />}
    </section>
  );
};

export default HeaderImage;
